module.exports = __webpack_public_path__ + "static/img/serverNew4.0dd6fa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/serverNew4.jpg
// module id = +8ai
// module chunks = 0